import React, { useState, useRef, useEffect } from "react";

import "./../Steps.scss";
import { Button, Form, Input, Select, Radio, Space } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import { useMediaQuery } from "@mui/material";
import infoIcon from "../../../../assets/images/png/info.png";
import addIcon from "../../../../assets/images/svg/newDesign/addIcon.svg";
import infoicon from "../../../../assets/images/svg/newDesign/infoicon.svg";
import { Popover } from "antd";
import { Label } from "evergreen-ui";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getSpeciality } from "../../../../pages/updateProfile/redux/thunk";
import {
  selectServices,
  selectServicesLoader,
  selectSpeciality,
  selectSpecialityLoader,
} from "../../../../pages/updateProfile/redux/slice";
import Loader from "../../../loader/Loader";
import API from "../../../../utils/customAxios";
import SelectElements from "./SelectElements";
import { getDiseases } from "../../../../pages/appointments/redux/thunk";
import {
  selectDiseases,
  selectDiseasesLoading,
} from "../../../../pages/appointments/redux/slice";
import Cookies from "js-cookie";
import { isElementRepeated } from "../../../../helpers/utilityHelper";

const { Option } = Select;

let index = 0;
const PracticeDetail = (props) => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width:767px)");

  const {
    servicesLoader,
    diseasesLoader,
    addSelectPair,
    selectPairs,
    handleFirstSelectChange,
    removeSelectPair,
    form,
    selectedSpecialities,
    setSelectedSpecialities,
  } = props;

  const specialities = useAppSelector(selectSpeciality);
  const specialityLoader = useAppSelector(selectSpecialityLoader);


  
  const [name, setName] = useState("");
  const [items, setItems] = useState([
    "Acne",
    "Diabetes",
    "Hypertension",
    "Other",
  ]);
  const inputRef = useRef(null);
  const [showAddItem, setShowAddItem] = useState(false); // State to control the visibility of Add item field and button

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [specialityError, setSpecialityError] = useState(false);

  function handleDuplicateSpeciality(_, specialityId) {
    const prefilledSpecialities = [];
    selectPairs?.forEach((pair, index) => {
      let value = form?.getFieldValue(`speciality${index + 1}`);
      prefilledSpecialities.push(value);
    });

    const alreadyExists = isElementRepeated(
      prefilledSpecialities,
      specialityId
    );
    if (alreadyExists) {
      return Promise.reject("Please choose a different speciality");
    } else {
      return Promise.resolve();
    }
  }

  function handleDuplicateService(_, serviceId) {
    const alreadyExists = isElementRepeated(selectedServices, serviceId);
    if (alreadyExists) {
      return Promise.reject("Please choose a different service");
    } else {
      return Promise.resolve();
    }
  }

  function handleDuplicateDisease(_, diseaseId) {
    const alreadyExists = isElementRepeated(selectedDiseases, diseaseId);
    if (alreadyExists) {
      return Promise.reject("Please choose a different condition");
    } else {
      return Promise.resolve();
    }
  }

  function handleSpecialityChange(value) {
    setSelectedSpecialities([...selectedSpecialities, value]);
  }

  function handleServiceChange(value) {
    setSelectedServices([...selectedServices, value]);
  }

  function handleDiseaseChange(value) {
    setSelectedDiseases([...selectedDiseases, value]);
  }

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    if (name !== "Other") {
      // setItems([...items, name || `New item ${index++}`]);// Add new item at the end
      setItems([name || `New item ${index++}`, ...items]); // Add new item at the beginning
    }
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    dispatch(getSpeciality());
  }, []);

  console.log(selectPairs, "selectPairs");

  const [showInfo, setShowInfo] = useState(false);

  const toggleInfo = () => {
    setShowInfo((prev) => !prev);
  };

  // useEffect(() => {
  //     if (currentSpeciality) {
  //         API.get(`/services?speciality_id=${currentSpeciality}`)
  //             .then((res) => {
  //                 setServicesArray([...servicesArray, {
  //                     currentSpeciality: res?.data?.data?.services
  //                 }])
  //             })
  //             .catch((err) => console.log(err));
  //     }
  // }, [currentSpeciality])

  const handleConditionsChange = (value) => {
    setShowAddItem(!showAddItem);
    setShowAddItem(value.includes("Other"));
  };

  const { TextArea } = Input;

  return (
    <>
      {(specialityLoader || servicesLoader || diseasesLoader) && <Loader />}
      {isMobile && (
        <div className="info-container">
          <img
            src={infoicon}
            className="img-fluid"
            alt="info"
            onClick={toggleInfo}
            style={{ cursor: "pointer" }}
          />
          <h6 className="info-heading">Why This Information Matters</h6>
          <h6 className="info-heading" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9.62109 17.2637L14.6211 12.2637L9.62109 7.26367"
              stroke="#0F345A"
              strokeWidth="1.69847"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {/* Conditionally render info content */}
          {showInfo && (
            <div className="info-popup">
              <p>
                Your<b> "About Me" </b>section is the first impression for
                potential patients. It helps them decide if you are the right
                doctor for their needs.
                <br></br> <br></br>
                Our team will review and enhance your "About Me" section to
                ensure it is optimized for search engines. This will increase
                your profile's visibility and help more patients connect with
                you.
              </p>
            </div>
          )}
        </div>
      )}
      <Row style={{ height: !isMobile ? "725px" : "" }}>
        <Col lg={6}>
          <Row className={`${!isMobile ? "pe-3" : ""}`}>
            <Col lg={12} md={12}>
              <Form.Item
                name="pmdc"
                label={
                  <span>
                    PMDC Number{" "}
                    <small style={{ fontSize: "15px" }}>
                      (not mandatory for all)
                    </small>
                  </span>
                }
                // rules={[
                //     { required: true, message: 'PMDC number is required' },
                //     { pattern: /^\d+$/, message: 'PMDC number should only contain numeric values' },
                //     { max: 13, message: 'PMDC number cannot exceed 13 characters' }
                // ]}
              >
                <Input
                  maxLength="7"
                  disabled
                  placeholder="Enter PMDC number"
                  // onKeyDown={(evt) => {
                  //     const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
                  //     if (!/\d/.test(evt.key) && !allowedKeys.includes(evt.key)) {
                  //         evt.preventDefault();
                  //     }
                  // }}
                />
              </Form.Item>
            </Col>
            <Col lg={12} md={12}>
              <Form.Item
                name="about"
                label="About me"
                className="textarea_style aboutme"
                rules={[
                  { required: true, message: "Please enter your bio" },
                  { min: 10, message: "Bio must be at least 10 characters" }
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength="500"
                  placeholder="Please share a brief bio to provide additional information about yourself..."
                />
              </Form.Item>
            </Col>
            {!isMobile && (
              <Col lg={12} md={12} className="infoBox001">
                <h6>
                  <img src={infoicon}></img> Why This Information Matters
                </h6>
                <p>
                  Your<b> "About Me" </b>section is the first impression for
                  potential patients. It helps them decide if you are the right
                  doctor for their needs.
                  <br></br> <br></br>
                  Our team will review and enhance your "About Me" section to
                  ensure it is optimized for search engines. This will increase
                  your profile's visibility and help more patients connect with
                  you.
                </p>
              </Col>
            )}
          </Row>
        </Col>
        <Col
          lg={6}
          style={{ height: !isMobile ? "640px" : "" }}
          className={`${!isMobile ? 'scrollable' : ''}`}
        >
          <Row className={`${!isMobile? 'ps-3' : 'pt-4'}`}>
              <Col lg={12} md={12}>
                <div className="spacialtyBo">
                  <h3>Specialty</h3>
                  <button
                    style={{ position: "relative", right: "45px" }}
                    className="ant-btn ant-btn-default add-btn btn"
                    type="button"
                    onClick={addSelectPair}
                  >
                    <img src={addIcon} className="img-fluid"></img>
                    {isMobile ? 'Add' : 'Add Speciality'}
                  </button>
                </div>
              </Col>
            {specialities?.length > 0 &&
              selectPairs?.map((pair) => (
                <SelectElements
                  key={pair.id}
                  id={pair.id}
                  firstSelectValue={pair.firstSelectValue}
                  secondSelectOptions={pair.secondSelectOptions}
                  thirdSelectOptions={pair.thirdSelectOptions}
                  onChange={handleFirstSelectChange}
                  onRemove={removeSelectPair}
                  specialities={specialities}
                  handleDuplicateSpeciality={handleDuplicateSpeciality}
                  handleDuplicateService={handleDuplicateService}
                  handleDuplicateDisease={handleDuplicateDisease}
                  handleSpecialityChange={handleSpecialityChange}
                  handleServiceChange={handleServiceChange}
                  handleDiseaseChange={handleDiseaseChange}
                  form={form}
                />
              ))}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default PracticeDetail;
